var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatientProgress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 91.5L23 106.5C23 107.605 23.8954 108.5 25 108.5L30.9444 108.5L32 108.5C33.1046 108.5 34 107.605 34 106.5L34 91.5C34 90.3954 33.1046 89.5 32 89.5L25 89.5C23.8954 89.5 23 90.3954 23 91.5Z",
    fill: "#D1EAFC",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 82.5L44 106.5C44 107.605 44.8954 108.5 46 108.5L51.9444 108.5L53 108.5C54.1046 108.5 55 107.605 55 106.5L55 82.5C55 81.3954 54.1046 80.5 53 80.5L46 80.5C44.8954 80.5 44 81.3954 44 82.5Z",
    fill: "#D1EAFC",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65 71.5L65 106.5C65 107.605 65.8954 108.5 67 108.5L72.9444 108.5L74 108.5C75.1046 108.5 76 107.605 76 106.5L76 71.5C76 70.3954 75.1046 69.5 74 69.5L67 69.5C65.8954 69.5 65 70.3954 65 71.5Z",
    fill: "#D1EAFC",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86 48.5L86 106.5C86 107.605 86.8954 108.5 88 108.5L93.9444 108.5L95 108.5C96.1046 108.5 97 107.605 97 106.5L97 48.5C97 47.3954 96.1046 46.5 95 46.5L88 46.5C86.8954 46.5 86 47.3954 86 48.5Z",
    fill: "#D1EAFC",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6289 29.2704C90.9096 24.4294 90.3877 23.9519 83.4307 13.749",
    stroke: "#333333",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4102 24.9232C73.1287 21.4476 73.7261 21.1465 82.9199 13.5837",
    stroke: "#333333",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0323 65.2738C27.9758 68.9323 44.6468 66.6448 56.0434 58.8226C65.9914 53.2084 81.9864 32.0451 82.9009 14.6427",
    stroke: "#333333",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8678 63.4576C19.8645 62.9955 18.6766 63.4342 18.2145 64.4375C17.7525 65.4408 18.1912 66.6287 19.1945 67.0908L20.8678 63.4576ZM56.0422 58.823L57.174 60.4719L56.0422 58.823ZM84.9201 12.7871C84.2548 11.9054 83.0006 11.73 82.119 12.3954L67.7509 23.2379C66.8692 23.9032 66.6938 25.1573 67.3592 26.039C68.0245 26.9207 69.2787 27.0961 70.1604 26.4308L82.9319 16.793L92.5697 29.5646C93.2351 30.4463 94.4892 30.6217 95.3709 29.9563C96.2526 29.291 96.428 28.0368 95.7626 27.1551L84.9201 12.7871ZM19.1945 67.0908C23.6897 69.1611 30.3083 69.4483 37.069 68.3269C43.8928 67.195 51.1958 64.5751 57.174 60.4719L54.9105 57.174C49.4921 60.893 42.7613 63.328 36.4145 64.3808C30.0047 65.444 24.316 65.0457 20.8678 63.4576L19.1945 67.0908ZM57.174 60.4719C67.1261 53.6412 73.8565 44.1705 78.236 35.4307C82.6115 26.6991 84.7023 18.5742 85.3044 14.2688L81.343 13.7148C80.8021 17.582 78.8437 25.2894 74.6599 33.6387C70.4802 41.9797 64.1413 50.8383 54.9105 57.174L57.174 60.4719Z",
    fill: "#A3C5FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientProgress);
export default __webpack_public_path__ + "static/media/patient-progress.8afd5019.svg";
export { ForwardRef as ReactComponent };